import { Row, Col, Card, Button } from "antd";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import EditRecordModal from "../components/EditRecordModal";
function ViewData() {
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const [editingRecord, setEditingRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    setLoading(true);
    fetchData(params.id, params.type);
  }, [params, refresh]);

  const handleEdit = (record) => {
    setEditingRecord(record);
    setIsModalVisible(true);
  };
  const handleSave = (values) => {
    console.log(values, "values");
    setLoading(true);
    request({
      url: `/admin/downtown/edit-data/${editingRecord._id}`,
      method: "POST",
      data: values,
      onSuccess: (data) => {
        console.log(data, "data");
        setLoading(false);
        if (data.status) {
          setLoading(false);
          ShowToast(data.message, Severty.SUCCESS);
          setIsModalVisible(false);
          setRefresh((prev) => !prev);
        } else {
          setLoading(false);
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error.response.data.errors[0].message, Severty.ERROR);
        setLoading(false);
      },
    });
  };
  const fetchData = (id, type) => {
    request({
      url: `/admin/downtown/view-data/${id}/${type ? type : "refine"}`,
      method: "get",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  return (
    <Main>
      <div style={{ marginBottom: "16px", display: "flex", gap: "10px" }}>
        <Button type="primary" onClick={() => navigate(-1)}>
          Back
        </Button>
        <Button onClick={() => handleEdit(list)}>
          <i className="fas fa-edit"></i>
        </Button>
      </div>
      <Card title="Data Detail">
        <Row gutter={[16, 16]}>
          <Col span={24} lg={12}>
            <div className="view-main-list view-main-list-new-mainhj8uyhgt">
              <div className="view-inner-cls">
                <h5>File Name:</h5>
                <h6>{list && list.downtownData ? list.downtownData.file_name : "--"}</h6>
              </div>

              <div className="view-inner-cls">
                <h5>Name:</h5>
                <h6>{list && list.name ? list.name : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Email:</h5>
                <h6>{list && list.email ? list.email : "--"}</h6>
              </div>
              <div className="view-inner-cls">


                <h5>Property Number:</h5>
                <h6>
                  {list && list.property_number ? list.property_number : "--"}
                </h6>
              </div>
              <div className="view-inner-cls">
                <h5>Name:</h5>
                <h6>{list && list.name ? list.name : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Email:</h5>
                <h6>{list && list.email ? list.email : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Phone:</h5>
                <h6>{list && list.phone ? list.phone : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Country Code:</h5>
                <h6>{list && list.country_code ? list.country_code : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Mobile Number:</h5>
                <h6>
                  {list && list.mobile_number ? list.mobile_number : "--"}
                </h6>
              </div>
              <div className="view-inner-cls">
                <h5>Full Mobile Number:</h5>
                <h6>
                  {list && list.country_code && list.mobile_number
                    ? list.country_code + " " + list.mobile_number
                    : "--"}
                </h6>
              </div>
              <div className="view-inner-cls">
                <h5>Secondary Mobile:</h5>
                <h6>
                  {list && list.secondary_mobile ? list.secondary_mobile : "--"}
                </h6>
              </div>
            </div>
          </Col>
          <Col span={24} lg={12}>
            <div className="view-main-list view-main-list-new-mainhj8uyhgt">
              <div className="view-inner-cls">
                <h5>Project Name:</h5>
                <h6>{list && list.downtownData ? list.downtownData.projectData ? list.downtownData.projectData.name : "" : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Location Name:</h5>
                <h6>{list && list.downtownData ? list.downtownData.locationData ? list.downtownData.locationData.name : "" : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Rooms:</h5>
                <h6>{list && list.room_description ? list.room_description : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Plot Number:</h5>
                <h6>{list && list.plot_number ? list.plot_number : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Flat Number:</h5>
                <h6>{list && list.flat_number ? list.flat_number : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Floor:</h5>
                <h6>{list && list.floor ? list.floor : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Parking Number:</h5>
                <h6>
                  {list && list.parking_number ? list.parking_number : "--"}
                </h6>
              </div>
              <div className="view-inner-cls">
                <h5>Common Area:</h5>
                <h6>{list && list.common_area ? list.common_area : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Actual Area:</h5>
                <h6>{list && list.actual_area ? list.actual_area : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Municipality Number:</h5>
                <h6>
                  {list && list.municioality_number
                    ? list.municioality_number
                    : "--"}
                </h6>
              </div>

              <div className="view-inner-cls">
                <h5>Comment:</h5>
                <h6>{list && list.note ? list.note : "--"}</h6>
              </div>
            </div>
          </Col>
        </Row>
      </Card>
      <EditRecordModal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSave={handleSave}
        record={editingRecord}
        visibleFields={list}
      />
    </Main>
  );
}
export default ViewData;
